import React, { useEffect, useState } from "react";
import { Container, Text, Title, Paper, Loader, Button } from "@mantine/core";
import { Link } from "wouter";
import { useStore } from "../store";
import { getTenantProfile } from "../api";
import { spendableSkus } from "../utils/skus";

function PaymentSuccess() {
  const tenantProfile = useStore((state) => state.tenantProfile);
  const setTenantProfile = useStore((state) => state.setTenantProfile);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      getTenantProfile().then((data) => {
        setTenantProfile(data);
        setIsLoading(false);
      });
    }, 2000);
    return () => clearTimeout(t);
  }, [setTenantProfile]);

  const skus = spendableSkus(tenantProfile?.creditTotals);

  return (
    <Container size="sm" ta="center">
      <Paper mt="xl" p="lg" withBorder>
        <Title mb="md" order={2}>
          Payment successful
        </Title>

        {isLoading ? (
          <>
            <Loader />
            <Text>Adding SKUs to your account…</Text>
          </>
        ) : (
          <div>
            <Text>
              You now have {skus.toLocaleString()} SKUs ready to use.
            </Text>
            {tenantProfile?.firstPurchaseBonusGranted && (
              <Text size="sm" c="dimmed" mt="sm">
                First-purchase bonus of 100 SKUs is included when this was your
                first paid checkout.
              </Text>
            )}
            <Button component={Link} to="/home" mt="lg">
              Continue
            </Button>
          </div>
        )}
      </Paper>
    </Container>
  );
}

export default PaymentSuccess;
